import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { reducer } from './report.reducer';
import { ReportEffects } from './report.effects';

export const FEATURE_NAME = 'report';
@NgModule({
    imports: [CommonModule, StoreModule.forFeature(FEATURE_NAME, reducer), EffectsModule.forFeature([ReportEffects])],
    providers: [ReportEffects],
})
export class ReportStoreModule {}
